module.exports = __webpack_public_path__ + "static/media/error-icon.4a8353bc.svg";